// pages/_app.tsx
import "@/styles/globals.css";
import { cn } from "@promptwatch/ui/lib/utils";
import type { AppProps } from "next/app";
import { Geist, Geist_Mono } from "next/font/google";
import { useEffect } from "react";
import { Router } from "next/router";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { ModalProvider } from "@/components/modals";
import { trpc } from "@/utils/trpc";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

// PostHog configuration constants
const NEXT_PUBLIC_POSTHOG_KEY = "phc_gRl10m0T1YJDelAs5V24Fwv6Iz1giTq3u6X4zbgpOVN";
const NEXT_PUBLIC_POSTHOG_HOST = "https://eu.i.posthog.com";

function App({ Component, pageProps }: AppProps) {
  useEffect(() => {
    posthog.init(NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: NEXT_PUBLIC_POSTHOG_HOST,
      person_profiles: "identified_only",
      loaded: (posthog) => {
        if (process.env.NODE_ENV === "development") posthog.debug();
      },
    });

    const handleRouteChange = () => posthog?.capture("$pageview");

    Router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  return (
    <PostHogProvider client={posthog}>
      <style jsx global>{`
        html {
          font-family: ${geistSans.style.fontFamily};
        }
      `}</style>
      <main className={cn(geistSans.variable, geistMono.variable, "font-sans antialiased ")}>
        <Component {...pageProps} />
        <ModalProvider />
      </main>
    </PostHogProvider>
  );
}

export default trpc.withTRPC(App);
